/* eslint import/prefer-default-export: "off" */
import type { Step } from '@src/components/setup.steps/models'
import { UserInformation } from '@src/components/setup.steps/account.information'
import AlertSettings from '@src/components/setup.steps/alert.settings'
import { SubmitFooter } from '../components'
import type { TabProps } from '@src/components/common/circle.tabs/components/item.circle.tab'
import { AlertSeverityEnum } from '@src/endpoints/services/commonHdr.service'

export type AlertSeveritySettingKey =
  | 'alertshigh'
  | 'alertsmedium'
  | 'alertslow'

export type SettingTabKey = 'profile'
export type SettingsTabUrl = SettingTabKey | AlertSeveritySettingKey
export interface Setting extends Omit<Step, 'stepType'>, TabProps {
  url: SettingsTabUrl
  severity?: AlertSeverityEnum
}

export type AlertSeveritySettingsDict = {
  [key in AlertSeveritySettingKey]?: Setting
}

const AlertSeveritySettings: AlertSeveritySettingsDict = {
  alertshigh: {
    id: 2,
    url: 'alertshigh',
    title: 'Alerts High',
    className: 'alertSettings',
    component: AlertSettings,
    footerComponent: SubmitFooter,
    severity: AlertSeverityEnum.ALERT_SEVERITY_HIGH
  },
  alertsmedium: {
    id: 3,
    url: 'alertsmedium',
    title: 'Alerts Medium',
    className: 'alertSettings',
    component: AlertSettings,
    footerComponent: SubmitFooter,
    severity: AlertSeverityEnum.ALERT_SEVERITY_MEDIUM
  },
  alertslow: {
    id: 4,
    url: 'alertslow',
    title: 'Alerts Low',
    className: 'alertSettings',
    component: AlertSettings,
    footerComponent: SubmitFooter,
    severity: AlertSeverityEnum.ALERT_SEVERITY_LOW
  }
}

const Settings: { [key in SettingTabKey]?: Setting } = {
  profile: {
    id: 1,
    url: 'profile',
    title: 'User Information',
    className: 'userInformation',
    component: UserInformation,
    footerComponent: SubmitFooter
  },
  ...AlertSeveritySettings
}

export { Settings, AlertSeveritySettings }
